import { Tooltip } from '@brightdrop/bd-ui';
import { IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { SIDEKICK_TRANSLATION_NAMESPACE } from '../../translations';
import { EditGlyph } from '../icons';
import useMessageActionButtonStyles from '../messageActionButton.styles';

const EDIT_ICON_SIZE_PX = 16;

/** Props for the latest-query edit action. */
export type MessageEditButtonProps = {
  disabled: boolean;
  onClick: () => void;
  testId: string;
};

/** Opens the inline edit form for the latest user query. */
function MessageEditButton({
  disabled,
  onClick,
  testId,
}: MessageEditButtonProps) {
  const { classes } = useMessageActionButtonStyles();
  const { t } = useTranslation(SIDEKICK_TRANSLATION_NAMESPACE);

  return (
    <Tooltip
      placement="top"
      content={t('chat.edit.tooltip')}
      trigger={
        <span>
          <IconButton
            className={classes.button}
            onClick={onClick}
            disabled={disabled}
            aria-label={t('chat.edit.ariaLabel')}
            data-testid={testId}
          >
            <EditGlyph size={EDIT_ICON_SIZE_PX} />
          </IconButton>
        </span>
      }
    />
  );
}

export default MessageEditButton;
